import { type AtomEffect } from 'recoil';
import { BOUND } from '../types/types';
import { jobAtom } from '../atoms/jobAtom';
import { jobIdAtom } from '../atoms/jobIdAtom';

type localStorageReceiptType = <T>(key: string) => AtomEffect<T>;

export const localStorageReceipt: localStorageReceiptType =
    (key) =>
    ({ setSelf, onSet, getPromise, trigger, node }) => {
        const setFromLocalIfReceipt = async (): Promise<void> => {
            const { jobStatus, isPendingCompletion } = await getPromise(jobAtom);
            const jobId = await getPromise(jobIdAtom);
            if (jobStatus === BOUND || isPendingCompletion) {
                const savedValue = localStorage.getItem(`${key}-${jobId}`);
                if (savedValue != null) {
                    setSelf(JSON.parse(savedValue));
                }
            }
        };
        if (trigger === 'get') {
            void setFromLocalIfReceipt();
        }

        onSet((newValue, _, isReset) => {
            void getPromise(jobIdAtom).then((jobId) => {
                if (isReset) {
                    localStorage.removeItem(`${key}-${jobId}`);
                } else {
                    localStorage.setItem(`${key}-${jobId}`, JSON.stringify(newValue));
                }
            });
        });
    };
